export function escapeVSNR(vsnr: string): string {
  // dots '.' and slashs '/' are deleted
  const escapedVSNR = vsnr.replace(/\./g, '').replace(/\//g, '')

  if (/^\d+$/.test(escapedVSNR)) {
    return escapedVSNR.replace(/^0+/, '')
  }

  return escapedVSNR
}

export function isValidVSNR(vsnr: string): boolean {
  const escapedVSNR = escapeVSNR(vsnr)
  const regex1 = /^\d{7,12}$/
  return regex1.test(escapedVSNR)
}
